// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bbg_a bfq_b bfq_tt bfq_qy bfq_qz bfq_un","PanelFooter--link":"bbg_b"};